// src/components/receipts/ReceiptRow.tsx
import React from "react";
import { SavingEntry } from "../../types";

interface ReceiptRowProps {
  entry: SavingEntry;
}

const ReceiptRow: React.FC<ReceiptRowProps> = ({ entry }) => {

  const formatCurrency = (amount: number): string => {
    return amount.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
      maximumFractionDigits: 0,
    });
  };

  const formatDate = (dateString: string): string => {
    return new Date(dateString).toLocaleDateString();
  };

  return (
    <tr className="border-t border-gray-700 hover:bg-gray-700">
      <td className="px-6 py-4">{entry.department}</td>
      <td className="px-6 py-4">{entry.vendor || "N/A"}</td>
      <td className="px-6 py-4">{entry.description}</td>
      <td className="px-6 py-4">{formatDate(entry.date)}</td>
      <td className="px-6 py-4 text-right">
        <span
          className={
            entry.type === "recurring" ? "text-green-400" : "text-blue-400"
          }
        >
          {formatCurrency(entry.amount)}
          {entry.type === "recurring" && (
            <span className="text-xs text-gray-400 ml-1">/mo</span>
          )}
        </span>
      </td>
      <td className="px-6 py-4 text-center">
        <span
          className={`px-2 py-1 rounded text-xs ${
            entry.type === "recurring"
              ? "bg-green-900 text-green-300"
              : "bg-blue-900 text-blue-300"
          }`}
        >
          {entry.type === "recurring" ? "Recurring" : "One-Time"}
        </span>
      </td>
    </tr>
  );
};

export default ReceiptRow;
